"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeHubSelector = void 0;

var _Hubs = require("self-service-api/constants/Hubs");

var activeHubSelector = function activeHubSelector() {
  var pathname = window.location.pathname;
  var match = pathname.match(/(\/sales)|(\/service)|(\/marketing)|(\/cms)/);
  if (!match) return null;
  if (match[1]) return _Hubs.HUB_SALES;
  if (match[2]) return _Hubs.HUB_SERVICE;
  if (match[3]) return _Hubs.HUB_MARKETING;
  if (match[4]) return _Hubs.HUB_CMS;
  return null;
};

exports.activeHubSelector = activeHubSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/ActiveHubSelectors.js
// module id = 122
// module chunks = 5 6